import { incaAccessor } from '@cancercentrum/inca';
import { SaveInRegistryButton } from './SaveInRegistry/SaveInRegistryButton';
import { SendToButton } from './SendTo/SendToButton';
import { LeaveInInboxButton } from './LeaveInInbox/LeaveInInboxButton';
import { DeleteButton } from './Delete/DeleteButton';
import { PrintButton } from './SystemButtons/PrintButton';
import { CompareButton } from './SystemButtons/CompareButton';
import { ImportDataButton } from './SystemButtons/ImportDataButton';
import { ReviewFormButton } from './ReviewForm/ReviewFormButton';
import { RetakeButton } from './Retake/RetakeButton';
import { ErrandInformationButton } from './ErrandInformation/ErrandInformationButton';
import { DataAccessAdministrationButton } from './DataAccessAdministration/DataAccessAdministrationButton';
export const Buttons = [
    SaveInRegistryButton,
    SendToButton,
    LeaveInInboxButton,
    DeleteButton,
    CompareButton,
    ReviewFormButton,
    ImportDataButton,
    PrintButton,
    RetakeButton,
    DataAccessAdministrationButton,
    ErrandInformationButton
];
export const reduceButtonRules = (rules, ctx)=>{
    return rules.reduce((res, rule)=>{
        if (res.state === 'Hidden') {
            return res;
        }
        const row = ctx.store.getState().data.present;
        const inca = incaAccessor();
        const cur = rule.evaluateState(row, inca, ctx);
        if (!cur) {
            return res;
        }
        if (cur.state === 'Hidden') {
            return cur;
        }
        return res.state === 'Disabled' ? res : cur;
    }, {
        state: 'Visible'
    });
};
